import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  loadFailed: false,
}

const setOrderInfo = (state, { payload }) =>
  updateObject(state, { ...state, ...payload })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PAYMENT_ORDERS/SET_ORDER_INFO':
      return setOrderInfo(state, action)
    default:
      return state
  }
}

export default reducer
